export default __webpack_public_path__ + "static/media/expandBox.2509ada6.svg";